export namespace CallNative {
    export function runSetEpicContext() {
        console.log('call globalPudge now.....');
        try {
            if (isIos()) {
                const _window: any = window;
                _window.webkit.messageHandlers.runSetEpicContext.postMessage({ 'runSetEpicContext': 'Start' });
            } else if (isAndroid()) {
                const _window: any = window;
                _window.injs.runSetEpicContext();
            }
        } catch (e) {
            console.log(e);
        }

    }
    export function setNativeNavTitle(title_cn: string = '', title_en: string = '') {
        console.log('set title ....');
        try {
            const param = {
                title_cn: title_cn,
                title_en: title_en
            };
            if (isIos()) {
                const _window: any = window;
                _window.webkit.messageHandlers.nativeSetNavTitle.postMessage(param);
            } else if (isAndroid()) {
                const _window: any = window;
                _window.injs.nativeSetNavTitle(JSON.stringify(param));
            }
        } catch (e) {
            console.log(e);
        }
    }
    export function runNativeFun(fun: string, params: any = { 'body': 'invoke' }) {
        const emptyParamFuntions = [
            'nativeGoRegister',
            'nativeGoMe',
            'nativeGoOrder',
            'nativeGoHome'
        ];
        const shouldClosePage = [
            'nativeGoRegister',
            'nativeGoMe',
            'nativeGoOrder',
            'nativeGoHome'
        ];
        try {
            if (isIos()) {
                const _window: any = window;
                _window.webkit.messageHandlers[fun].postMessage(params);
            } else if (isAndroid()) {
                const _window: any = window;
                if (emptyParamFuntions.indexOf(fun) > -1) {
                    _window.injs[fun]();
                } else {
                    _window.injs[fun](JSON.stringify(params));
                }
            }
            if (fun !== 'nativeClose' && shouldClosePage.indexOf(fun) > -1) {
                console.log('calling native ' + fun);
                runNativeFun('nativeClose');
            }
        } catch (e) {
            console.log(e);
        }
    }
    export function nativeGoRegister() {
        try {
            console.log('go register');
            if (isIos()) {
                const _window: any = window;
                _window.webkit.messageHandlers.nativeGoRegister.postMessage({ 'body': 'nativeGoRegister' });
            } else if (isAndroid()) {
                const _window: any = window;
                _window.injs.nativeGoRegister();
            }
        } catch (e) {
            console.log(e);
        }
    }
    export function isIos() {
        return (/iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase()));
    }
    export function isAndroid() {
        return (/android/.test(navigator.userAgent.toLowerCase()));
    }
}
